// src/context/ThemeContext.js

import React, { createContext, useState, useEffect } from "react";
import { saveToLocal, getFromLocal } from "../function/functions";

const THEME_STORAGE_KEY = "theme";
const LIGHT = "light";
const DARK = "dark";

export const ThemeContext = createContext({
    theme: LIGHT,
    toggleTheme: () => {},
});

export const ThemeProvider = ({ children }) => {
    // Дефолт завжди light — темну тему бачить лише той, хто свідомо її обрав.
    const [theme, setTheme] = useState(LIGHT);

    useEffect(() => {
        const stored = getFromLocal(THEME_STORAGE_KEY);
        if (stored === DARK) {
            setTheme(DARK);
        }
    }, []);

    useEffect(() => {
        if (typeof document === "undefined") return;
        document.documentElement.setAttribute("data-theme", theme);
    }, [theme]);

    const toggleTheme = () => {
        setTheme((prev) => {
            const next = prev === DARK ? LIGHT : DARK;
            saveToLocal(THEME_STORAGE_KEY, next);
            return next;
        });
    };

    return (
        <ThemeContext.Provider value={{ theme, toggleTheme }}>
            {children}
        </ThemeContext.Provider>
    );
};
